import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import Navigation from '../../../layout/Navigation/Navigation';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
import CommonHeaderRight from './CommonHeaderRight';

const SummaryHeader = () => {
	const { width } = useDeviceScreen();

	return (
		<Header>
		
			<CommonHeaderRight />
		</Header>
	);
};

export default SummaryHeader;
